declare var loadEmployeesUrl;
declare var setEmployeeToProduction;
import * as Toastr from "toastr";

export class ElcProductionAddEmployee {
    constructor() {
        this.resetHTML();
        this.initHTML();
    }

    resetHTML() {
        $("#employee_type").val("Permanent");
        $("#temp_agency_div").hide();
    }

    initHTML() {
        const _this = this;
        $("#employee_type").on("change", function(){
            if ($(this).val() == "Temporary") {
                $("#temp_agency_div").show();
            } else {
                $("#temp_agency_div").hide();
            }
            _this.loadEmployees();
        });

        $("#temp_agency").on("change", function(){
            _this.loadEmployees();
            $("#checkAll").prop("checked", false);

        });

        $("#add-employee-btn").on("click", function(){
            _this.loadEmployees();
            $(".add-employee-form").modal("show");
        });

        $("#add-empolyee-submit").on("click", function(){
            let employeeIds = [];
            if($(".employee-tag:checked").length > 0) {
                $(".employee-tag:checked").each(function(){
                    employeeIds.push($(this).val());
                })
                $.ajax({
                    url: setEmployeeToProduction,
                    method: "post",
                    data: {employeeIds}
                }).then(response => {
                    if(response.message == "ok") {
                        window.location.reload();
                    } else {
                        Toastr.error(response.error);
                    }
                    console.log(response);
                })
            } else {
                Toastr.error("No Employee Selected");

            }
        });

        $("#checkAll").change(function () {
            if ($("#checkAll").prop("checked")) {
              $(".employee-tag").prop("checked", true);
            } else {
              $(".employee-tag").prop("checked", false);
            }
        });

        $('#employee_name').on('keyup keypress', function(e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
                e.preventDefault();
                $("#searchBtn").click();
            }
        });

        $("body").on("click", "#searchBtn", function(e){
            e.preventDefault();
            const employeeTypeName = $("#employee_type").val();
            const tempAgencyId = $("#temp_agency").val();
            const employeeName = $("#employee_name").val();
            $.ajax({
                url: loadEmployeesUrl,
                method: "get",
                data: {employee_type_name: employeeTypeName, temp_agency_id: tempAgencyId, employee_name: employeeName, page: 1}
            }).then(response => {
                let employeeTableHTML = "";
                $("#emp_pagination").html(response.paginations);
                response.results.forEach(employee => {
                    employeeTableHTML += _this.renderTableLine(employee);
                });
                $("#employeeDataTable").html(employeeTableHTML);
            });
          });

        $("body").on("click", "#emp_pagination a", function(e){
            e.preventDefault();
            $("#checkAll").prop("checked", false);
            const linkUrl = $(this).attr("href").replace(/page=/g,"").split("&");
            const pageNumber = parseInt(linkUrl[2]);
            const employeeTypeName = $("#employee_type").val();
            const tempAgencyId = $("#temp_agency").val();
            const employeeName = $("#employee_name").val();
            $.ajax({
                url: loadEmployeesUrl,
                method: "get",
                data: {employee_type_name: employeeTypeName, temp_agency_id: tempAgencyId, page: pageNumber, employee_name: employeeName}
            }).then(response => {
                let employeeTableHTML = "";
                $("#emp_pagination").html(response.paginations);
                response.results.forEach(employee => {
                    employeeTableHTML += _this.renderTableLine(employee);
                });
                $("#employeeDataTable").html(employeeTableHTML);
            });
          });
    }

    loadEmployees() {
        const employeeTypeName = $("#employee_type").val();
        const tempAgencyId = $("#temp_agency").val();
        const employeeName = $("#employee_name").val();
        const _this = this;

        $.ajax({
            url: loadEmployeesUrl,
            method: "get",
            data: {employee_type_name: employeeTypeName, temp_agency_id: tempAgencyId, employee_name: employeeName }
        }).then(response => {
            let employeeTableHTML = "";
            $("#emp_pagination").html(response.paginations);
            response.results.forEach(employee => {
                employeeTableHTML += _this.renderTableLine(employee);
            });
            $("#employeeDataTable").html(employeeTableHTML);
        });
    }

    renderTableLine(employee) {
        const employeeRowHTML = `<tr class="small-text center-content" >
                                    <td>
                                        <input type="checkbox" value="${employee.id}" class="employee-tag"/>
                                    </td>
                                    <td class="heighter">
                                        <img src="${employee.avatar_url}" class="img img-circle img-responsive" style="width: 50px; height: 50px">
                                    </td>
                                    <td>
                                        ${employee.first_name} <br/>${employee.last_name}
                                    </td>
                                    <td>
                                        ${employee.employee_type} <br/>
                                        ${employee.temp_agency}
                                    </td>
                                    <td>
                                        ${employee.role}
                                    </td>
                                    <td>
                                        ${employee.area}
                                    </td>
                                </tr>`;
      return employeeRowHTML;
    }
}
